import type { UserData } from 'chaika-frontend-types/frontend-cms';
import { RoleName } from 'chaika-enums';

export function isDoctor(user: UserData): boolean {
    return (user.roles || []).some(({ name }) => name === RoleName.Doctor);
}
